import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  Stack,
  Progress,
  Divider,
  Spinner,
  Card,
  CardHeader,
  CardBody,
  HStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { formatTime } from '../utils/formatters';

/**
 * CategoriasTickets - Component for displaying ticket categories and statistics
 * 
 * @param {Object} props - Component props
 * @param {Array} props.categorias - Array of category objects
 * @param {boolean} props.isLoading - Loading state
 * @param {number} props.tempoMedioGlobal - Global average resolution time in minutes
 */
const CategoriasTickets = ({ categorias, isLoading, tempoMedioGlobal }) => {
  const cardBg = useColorModeValue('white', 'gray.700');

  return (
    <Card bg={cardBg} boxShadow="md">
      <CardHeader pb={2}>
        <Heading size="md">Categorias de Tickets</Heading>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <Flex justify="center" py={6}>
            <Spinner />
          </Flex>
        ) : (
          <Stack spacing={4}>
            {categorias.map((categoria, index) => (
              <Box key={index}>
                <Flex justify="space-between" mb={1}>
                  <Text fontSize="sm" fontWeight="medium">{categoria.nome}</Text>
                  <HStack>
                    <Text fontSize="sm">{categoria.quantidade} tickets</Text>
                    <Text fontSize="sm" fontWeight="medium">({categoria.percentual}%)</Text>
                  </HStack>
                </Flex>
                <Flex align="center">
                  <Progress 
                    value={categoria.percentual} 
                    size="sm" 
                    flex="1" 
                    colorScheme={
                      index === 0 ? 'blue' :
                      index === 1 ? 'green' :
                      index === 2 ? 'red' :
                      index === 3 ? 'purple' :
                      index === 4 ? 'yellow' : 'gray'
                    }
                    borderRadius="full"
                  />
                  <Text fontSize="sm" ml={4} w="100px">
                    {formatTime(categoria.tempoMedio)}
                  </Text>
                </Flex>
              </Box>
            ))}
            
            <Divider my={2} />
            
            <Flex justify="space-between" fontSize="sm" fontWeight="medium">
              <Text>Total de categorias: {categorias.length}</Text>
              <Text>Tempo médio global: {formatTime(tempoMedioGlobal)}</Text>
            </Flex>
          </Stack>
        )}
      </CardBody>
    </Card>
  );
};

export default CategoriasTickets;